<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30" viewBox="0 0 31 30" fill="none">
        <circle cx="15.5684" cy="15" r="15" fill="#ADB5B9"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2449 15.8823V24.7059H16.2449V15.8823H24.392V13.8823H16.2449V6.17645H14.2449V13.8823H5.86255V15.8823H14.2449Z" fill="#232D33"/>
    </svg>
</template>